<template>
	<div>
		<b-modal
			:visible="showModal"
			id="loaderModal"
			centered
			hide-footer
			hide-header
			@hidden="$emit('update:showModal', false)"
			no-close-on-backdrop
			size="md"
		>
			<section
				class="w-100 d-flex flex-column align-items-center justify-content-center h-100"
			>
				<div>
					<Spinner :id="'modal'" :loaderText="loaderText" />
				</div>
			</section>
		</b-modal>
	</div>
</template>

<script>
import Spinner from "@/components/fixedcomponents/Spinner.vue";
export default {
	components: {
		Spinner,
	},
	props: {
		showModal: Boolean,
		loaderText: {
			type: Array,
			default: () => [
				"Parsing your resume",
				"Analysing your experience",
				"Extracting your skills",
				"Generating Recommendations",
			],
		},
	},
};
</script>

<style lang="postcss" scoped></style>
